export default "__VITE_ASSET__DsNzy6KK__"